export default __webpack_public_path__ + "static/media/chillerCarrierHX.590972f0.png";